export async function taskCallback(data = {}): Promise<void> {
  // 判断一下是否登录
  // const Login = Mach.requireModule('Login')
  // const isLogin = Login?.isLogin?.()
  // if (!isLogin) {
  //   return new Promise<any>((resolve, reject) => {
  //     reject(new Error('Not logged in'))
  //   })
  // }

  // @ts-ignore
  const networkModule = Mach.requireModule('Network')
  const url = 'dsp/launch/task/show/call/back'
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    data: {
      ...data,
    },
  }
  // @ts-ignore
  // const indicatorModule = Mach.requireModule('ActivityIndicator');
  // indicatorModule.showLoading();
  // indicatorModule.hideLoading();
  networkModule.requestWx(params, function (result: any) {
    const code = result?.data?.code ?? 1
    if (code === 0) {
      console.log(result.data)
    } else {
      console.log(result.data)
    }
  })
}
